<template>
    <div>
        <h1 class="display-heading">{{ pageTitle }}</h1>
        <form @submit.prevent="validate">
            <!-- <div class="form-group required">
                <label>Registration Number</label>
                <input
                    name="registrationNumber"
                    type="text"
                    placeholder="Registration Number"
                    v-model="form.registrationNumber"
                    data-vv-validate-on="blur"
                    data-vv-as="registration number"
                    v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('registrationNumber')
                }"
                />
                 <div v-show="validationErrors.has('registrationNumber')" class="invalid-feedback">
                    {{ validationErrors.first('registrationNumber') }}
                </div>
            </div> -->

            <div class="form-group required">
                <label>Product Name</label>
                <input
                    name="productName"
                    type="text"
                    placeholder="Product Name"
                    class="form-control"
                    v-model="form.productName"
                    data-vv-validate-on="blur"
                    data-vv-as="product name"
                    v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('productName')
                }"
                />
                 <div v-show="validationErrors.has('productName')" class="invalid-feedback">
                    {{ validationErrors.first('productName') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Active Ingredient</label>
                <input
                name="activeIngredient"
                    type="text"
                    placeholder="Active Ingredient"
                    class="form-control"
                    v-model="form.activeIngredient"
                    data-vv-validate-on="blur"
                    data-vv-as="active ingredient"
                    v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('activeIngredient')
                }"
                />
                 <div v-show="validationErrors.has('activeIngredient')" class="invalid-feedback">
                    {{ validationErrors.first('activeIngredient') }}
                </div>
            </div>

            <!-- <div class="form-group required">
                <label>Description</label>
                <input
                name="description"
                    type="text"
                    placeholder="Description"
                    class="form-control"
                    v-model="form.description"
                    data-vv-validate-on="blur"
                    data-vv-as="description"
                    v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('description')
                }"
                />
                 <div v-show="validationErrors.has('description')" class="invalid-feedback">
                    {{ validationErrors.first('description') }}
                </div>
            </div> -->

            <div class="form-group required">
                <label>Unit</label>
                <input
                name="unit"
                    type="text"
                    placeholder="Unit"
                    class="form-control"
                    v-model.number="form.unit"
                    data-vv-validate-on="blur"
                    data-vv-as="unit"
                    v-validate="'required|numeric|min_value:1'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('unit')
                }"
                />
                 <div v-show="validationErrors.has('unit')" class="invalid-feedback">
                    {{ validationErrors.first('unit') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Max Retail Price</label>
                <input
                    name="retailPrice"
                    type="text"
                    placeholder="Max Retail Price"
                    class="form-control"
                    v-model.number="form.retailPrice"
                    data-vv-validate-on="blur"
                    data-vv-as="raw price"
                    v-validate="'required|decimal:2|min_value:0.01'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('retailPrice')
                }"
                />
                 <div v-show="validationErrors.has('retailPrice')" class="invalid-feedback">
                    {{ validationErrors.first('retailPrice') }}
                </div>
            </div>

            <!-- <div class="form-group required">
                <label>Gross Price</label>
                <input
                name="priceGross"
                    type="text"
                    placeholder="Gross Price"
                    class="form-control"
                    v-model.number="form.priceGross"
                    data-vv-validate-on="blur"
                    data-vv-as="gross price"
                    v-validate="'required|decimal:2|min_value:0.01'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('priceGross')
                }"
                />
                 <div v-show="validationErrors.has('priceGross')" class="invalid-feedback">
                    {{ validationErrors.first('priceGross') }}
                </div>
            </div> -->

            <p class="small text-danger">
                * Indicates required fields.
            </p>

            <p
                v-if="shouldShowSubmitMessage"
                :class="{
                    'text-danger': submitHasError,
                }"
            >
                {{ submitMessage }}
            </p>

            <div v-if="!isAddProduct">
                <button
                    class="btn btn-primary btn-primary-insv mr-2"
                    type="button"
                    @click="saveChanges"
                    :disabled="isSaving"
                >
                    Save Changes
                </button>
                <button class="btn btn-secondary mr-2" @click="getDrugDetails">
                    Discard Changes
                </button>
            </div>

            <div v-if="isAddProduct">
                <button
                    v-if="!addSuccessful"
                    class="btn btn-primary btn-primary-insv mr-2"
                    type="button"
                    @click="addNewDrug"
                    :disabled="isSaving"
                >
                    Add Product
                </button>
            </div>

            <div class="mt-2">
                <router-link
                    :to="{
                        name: 'pharmacy-drugs-management',
                    }"
                    class="btn btn-secondary"
                >
                    Back to Drug List
                </router-link>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    'name': 'PharmacyDrugDetail',
    'computed': {
        drugId () {
            return this.$route.name === 'pharmacy-drugs-management-detail'
                ? this.$route.params.id
                : null;
        },
        isAddProduct () {
            return this.$route.name === 'pharmacy-drugs-management-new';
        },
        pageTitle () {
            return this.isAddProduct
                ? 'Add New Drug'
                : 'View / Edit Drug Details';
        },
        shouldShowSubmitMessage () {
            return this.submitMessage ? this.submitMessage.length > 0 : false;
        }
    },
    mounted () {
        this.getDrugDetails();
    },
    data () {
        return {
            'form': {
                // 'registrationNumber': '',
                // 'genericName': '',
                // 'brandName': '',
                // 'description': '',
                // 'priceRaw': '',
                // 'priceGross': ''
                'productName': '',
                'activeIngredient': '',
                'unit': '',
                'retailPrice': ''
            },
            'isSaving': false,
            'submitMessage': '',
            'submitHasError': false,
            'addSuccessful': false
        };
    },
    'methods': {
        validate () {
            return this.$validator.validateAll();
        },
        getDrugDetails () {
            if (!this.isAddProduct && this.drugId) {
                this.axios
                    .get('PharmacyDrug/GetDrugDetails', {
                        'params': {
                            'drugId': this.drugId
                        }
                    })
                    .then(({ data }) => {
                        let drugData = data.data;
                        // this.form.registrationNumber = drugData.rn;
                        // this.form.genericName = drugData.gn;
                        // this.form.brandName = drugData.bn;
                        // this.form.description = drugData.de;
                        // this.form.priceRaw = drugData.pr;
                        // this.form.priceGross = drugData.pg;
                        this.form.productName = drugData.pn;
                        this.form.activeIngredient = drugData.ai;
                        this.form.retailPrice = drugData.rp;
                        this.form.unit = drugData.u;
                    })
                    .catch(() => {});
            }
        },
        saveChanges () {
            this.validate().then((isValid) => {
                if (isValid) {
                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Saving drug details...';
                    this.axios
                        .post('PharmacyDrug/SaveDrugDetails', {
                            'di': this.drugId,
                            // 'rn': this.form.registrationNumber,
                            // 'gn': this.form.genericName,
                            // 'bn': this.form.brandName,
                            // 'de': this.form.description,
                            // 'pr': this.form.priceRaw,
                            // 'pg': this.form.priceGross
                            'pn': this.form.productName,
                            'ai': this.form.activeIngredient,
                            'rp': this.form.retailPrice,
                            'u': this.form.unit

                        })
                        .then(() => {
                            this.submitMessage = 'Drug details saved!';
                        })
                        .catch((error) => {
                            this.submitHasError = true;

                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage =
                            'Error saving drug details... Please try again.';
                            }
                        })
                        .finally(() => {
                            this.isSaving = false;
                        });
                }
            });
        },
        addNewDrug () {
            this.validate().then((isValid) => {
                if (isValid) {
                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Adding new drug...';
                    this.axios
                        .post('PharmacyDrug/AddNewDrug', {
                            // 'rn': this.form.registrationNumber,
                            // 'gn': this.form.genericName,
                            // 'bn': this.form.brandName,
                            // 'de': this.form.description,
                            // 'u': this.form.unit,
                            // 'pr': this.form.priceRaw,
                            // 'pg': this.form.priceGross
                            'pn': this.form.productName,
                            'ai': this.form.activeIngredient,
                            'rp': this.form.retailPrice,
                            'u': this.form.unit
                        })
                        .then(() => {
                            this.submitMessage = 'New drug added!';
                            this.addSuccessful = true;
                        })
                        .catch((error) => {
                            this.submitHasError = true;

                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage =
                            'Error saving drug details... Please try again.';
                            }
                        })
                        .finally(() => {
                            this.isSaving = false;
                        });
                }
            });
        }
    }
};
</script>

<style>
</style>
